<template>
  <v-container fluid fill-height v-on:keyup.enter="Login">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ labels.login }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="person"
                name="login"
                :label="labels.account"
                type="text"
                v-model="id"
              ></v-text-field>
              <v-text-field
                id="password"
                prepend-icon="lock"
                name="password"
                :label="labels.password"
                type="password"
                v-model="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="success" to="/">{{ labels.back }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-on:click="Login">{{ labels.login }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import languages from "../languages/Login.json";

export default {
  data: () => ({
    labels: {
      login: "",
      account: "",
      password: "",
      back: "",
    },
    id: "",
    password: "",
  }),
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    Login: function() {
      var language = "";
      if (this.$store.state.select_language.lang == "en") {
        language = "en-us";
      } else {
        language = "zh-tw";
      }

      var login_params = {
        Account: this.id,
        Password: this.password,
        Language: language,
      };
      this.$store.dispatch("postLogin", login_params);
    },
    setLanguage: function(select_language) {
      this.labels.login = languages.login[select_language.lang];
      this.labels.account = languages.account[select_language.lang];
      this.labels.password = languages.password[select_language.lang];
      this.labels.back = languages.back[select_language.lang];
    },
  },
};
</script>
